import { type ComponentProps } from 'react';

import { Menu, type MenuRootProps } from '@ark-ui/react';

import {
	MenuCheckboxItem,
	MenuContent,
	MenuGroup,
	MenuItem,
	MenuLabel,
	MenuRadioGroup,
	MenuRadioItem,
	MenuSeparator,
	MenuSubContent,
	MenuSubRoot,
	MenuSubTrigger
} from '../menu/menu-parts';

type ContextMenuRootProps = MenuRootProps;

function ContextMenuRoot({
	lazyMount = true,
	unmountOnExit = true,
	...props
}: ContextMenuRootProps) {
	return <Menu.Root lazyMount={lazyMount} unmountOnExit={unmountOnExit} {...props} />;
}

function ContextMenuTrigger({ className, ...props }: ComponentProps<typeof Menu.ContextTrigger>) {
	return <Menu.ContextTrigger className={className} {...props} />;
}

const ContextMenu = Object.assign(ContextMenuRoot, {
	Root: ContextMenuRoot,
	Trigger: ContextMenuTrigger,
	Content: MenuContent,
	Item: MenuItem,
	CheckboxItem: MenuCheckboxItem,
	RadioGroup: MenuRadioGroup,
	RadioItem: MenuRadioItem,
	Group: MenuGroup,
	Label: MenuLabel,
	Separator: MenuSeparator,
	Sub: MenuSubRoot,
	SubTrigger: MenuSubTrigger,
	SubContent: MenuSubContent
});

export { ContextMenu, type ContextMenuRootProps };
